<template>
  <div
    :class="[
      'tm-simple-skeleton',
      {
        'tm-simple-skeleton--rect': type === 'rect',
        'tm-simple-skeleton--chip': type === 'chip',
        'tm-simple-skeleton--circle': type === 'circle',
      },
    ]"
  />
</template>

<script setup lang="ts">
import type { SimpleSkeletonTypes } from '@/components/shared/types'
import type { StylesheetSizeProp } from '@/types'

withDefaults(
  defineProps<{
    type?: SimpleSkeletonTypes
    width?: StylesheetSizeProp
    height?: StylesheetSizeProp
    maxWidth?: StylesheetSizeProp | 'none'
    maxHeight?: StylesheetSizeProp | 'none'
  }>(),
  {
    type: 'rect',
    width: '100%',
    height: '100%',
    maxWidth: 'none',
    maxHeight: 'none',
  },
)
</script>

<style scoped lang="scss">
.tm-simple-skeleton {
  $width: var(--tm-skeleton-width, v-bind(width));
  $height: var(--tm-skeleton-height, v-bind(height));
  $maxWidth: var(--tm-skeleton-max-width, v-bind(maxWidth));
  $maxHeight: var(--tm-skeleton-max-height, v-bind(maxHeight));

  background-color: var(--tm-skeleton-color, $gray1);
  width: $width;
  height: $height;
  max-width: $maxWidth;
  max-height: $maxHeight;

  &--rect {
    border-radius: 4px;
  }

  &--chip {
    border-radius: calc($height / 2);
  }

  &--circle {
    aspect-ratio: 1;
    border-radius: 50%;
  }
}
</style>
